import React, {memo} from "react";
import ModerationItem from "./ModerationItem";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        width: '80%',
        height: '60vh',
        overflowY: "auto"
    }
})

const ModerationTable = ({items, onApprove, onReject}) => {

    const classes = useStyles()

    return (<div className={classes.root}>
        {items && items.map((item, i) =>
            <ModerationItem id={item.id} item={item} index={i} onApprove={onApprove} onReject={onReject}
        />)}
    </div>);
}

export default memo(ModerationTable)